export default "__VITE_ASSET__DPOytzsz__"